// Petals, edge fireworks, crackers, sparklers, and flower-pots.
// Drawn on a canvas. No audio. The card can be spared so the
// launch button and countdown stay clear.

export const CELEBRATION_MS = 7000;

const PETAL_COLORS = ["#FFFFFF", "#FF9933", "#E8B923", "#F6E2A8", "#C6A15B"];
const SPARK_COLORS = ["#FFFFFF", "#FF9933", "#FFD76A", "#E8B923", "#FFF4D2"];

function rand(min, max) {
  return min + Math.random() * (max - min);
}

function pick(list) {
  return list[(Math.random() * list.length) | 0];
}

export function fitInaugurationFrame(gate, frame) {
  if (!gate || !frame) return;
  frame.style.transform = "none";
  const styles = window.getComputedStyle(gate);
  const padX = (parseFloat(styles.paddingLeft) || 0) + (parseFloat(styles.paddingRight) || 0);
  const padY = (parseFloat(styles.paddingTop) || 0) + (parseFloat(styles.paddingBottom) || 0);
  const availableH = gate.clientHeight - padY;
  const availableW = gate.clientWidth - padX;
  const neededH = frame.offsetHeight;
  const neededW = frame.offsetWidth;
  if (availableH < 40 || availableW < 40 || !neededH || !neededW) return;
  const scale = Math.min(1, (availableH - 2) / neededH, (availableW - 2) / neededW);
  frame.style.transform = scale < 0.998 ? `scale(${scale})` : "none";
}

function makePetal(w, h, anywhere) {
  return {
    x: Math.random() * w,
    y: anywhere ? Math.random() * h : -20 - Math.random() * 80,
    vx: rand(-0.35, 0.35),
    vy: rand(0.45, 1.25),
    rot: Math.random() * Math.PI * 2,
    spin: rand(-0.035, 0.035),
    sway: Math.random() * Math.PI * 2,
    rw: rand(4.5, 8),
    rh: rand(8, 14),
    color: pick(PETAL_COLORS),
  };
}

function drawPetal(ctx, petal) {
  ctx.save();
  ctx.translate(petal.x, petal.y);
  ctx.rotate(petal.rot);
  ctx.fillStyle = petal.color;
  ctx.beginPath();
  ctx.moveTo(0, -petal.rh);
  ctx.bezierCurveTo(petal.rw, -petal.rh * 0.35, petal.rw * 0.85, petal.rh * 0.45, 0, petal.rh);
  ctx.bezierCurveTo(-petal.rw * 0.85, petal.rh * 0.45, -petal.rw, -petal.rh * 0.35, 0, -petal.rh);
  ctx.fill();
  if (petal.color === "#FFFFFF") {
    ctx.strokeStyle = "rgba(198, 161, 91, 0.9)";
    ctx.lineWidth = 1;
    ctx.stroke();
  }
  ctx.strokeStyle = "rgba(154, 82, 16, 0.28)";
  ctx.lineWidth = 0.7;
  ctx.beginPath();
  ctx.moveTo(0, -petal.rh * 0.65);
  ctx.lineTo(0, petal.rh * 0.7);
  ctx.stroke();
  ctx.restore();
}

function pushSpark(sparks, spark) {
  if (sparks.length > 420) sparks.splice(0, sparks.length - 380);
  sparks.push(spark);
}

function emitFountain(sparks, x, y, count, power) {
  for (let i = 0; i < count; i += 1) {
    const angle = -Math.PI / 2 + rand(-0.42, 0.42);
    const speed = rand(1.1, power);
    pushSpark(sparks, {
      kind: "dot",
      x: x + rand(-3, 3),
      y,
      vx: Math.cos(angle) * speed,
      vy: Math.sin(angle) * speed,
      life: 1,
      decay: rand(0.007, 0.014),
      color: pick(SPARK_COLORS),
      g: rand(0.02, 0.04),
      size: rand(1.1, 2.2),
    });
  }
}

function emitSparkler(sparks, x, y, count) {
  for (let i = 0; i < count; i += 1) {
    const angle = rand(-Math.PI * 0.95, -Math.PI * 0.05);
    const speed = rand(0.3, 1.7);
    pushSpark(sparks, {
      kind: "ray",
      x: x + rand(-2, 2),
      y: y + rand(-2, 2),
      vx: Math.cos(angle) * speed,
      vy: Math.sin(angle) * speed,
      life: 1,
      decay: rand(0.02, 0.045),
      color: Math.random() < 0.4 ? "#FFFFFF" : pick(SPARK_COLORS),
      g: 0.012,
      size: rand(1, 1.7),
    });
  }
}

function edgeX(side, w, zone) {
  if (!zone) {
    const reach = Math.min(52, Math.max(22, w * 0.05));
    return side === "left" ? rand(8, reach) : rand(w - reach, w - 8);
  }
  if (side === "left") return rand(4, Math.max(12, zone.l - 2));
  return rand(Math.min(w - 12, zone.r + 2), w - 4);
}

function burstFirework(sparks, side, w, h, reduced, zone) {
  const x = edgeX(side, w, zone);
  const y = h * rand(0.06, 0.58);
  const count = reduced ? 12 : 26;
  for (let i = 0; i < count; i += 1) {
    const angle = (Math.PI * 2 * i) / count + rand(-0.08, 0.08);
    const speed = rand(0.6, 2.4);
    let vx = Math.cos(angle) * speed;
    const vy = Math.sin(angle) * speed;
    if (side === "left" && vx < 0) vx *= 0.3;
    if (side === "right" && vx > 0) vx *= 0.3;
    pushSpark(sparks, {
      kind: "ray",
      x,
      y,
      vx,
      vy,
      life: 1,
      decay: rand(0.01, 0.02),
      color: pick(SPARK_COLORS),
      g: 0.014,
      size: rand(1.2, 2),
    });
  }
  pushSpark(sparks, {
    kind: "flash",
    x,
    y,
    vx: 0,
    vy: 0,
    life: 1,
    decay: 0.045,
    color: "#FFF6D8",
    g: 0,
    size: reduced ? 16 : 26,
  });
}

function popCracker(sparks, side, w, h, reduced, zone) {
  const x = edgeX(side, w, zone);
  const y = h * rand(0.16, 0.88);
  pushSpark(sparks, {
    kind: "flash",
    x,
    y,
    vx: 0,
    vy: 0,
    life: 1,
    decay: 0.09,
    color: "#FFFFFF",
    g: 0,
    size: 11,
  });
  const count = reduced ? 6 : 11;
  for (let i = 0; i < count; i += 1) {
    const angle = Math.random() * Math.PI * 2;
    const speed = rand(0.7, 2.5);
    pushSpark(sparks, {
      kind: "ray",
      x,
      y,
      vx: Math.cos(angle) * speed,
      vy: Math.sin(angle) * speed,
      life: 1,
      decay: rand(0.028, 0.05),
      color: i % 2 ? "#FF9933" : "#FFE08A",
      g: 0.018,
      size: 1.3,
    });
  }
}

function drawStick(ctx, x, y) {
  ctx.save();
  ctx.strokeStyle = "#6B3A1F";
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.moveTo(x, y + 34);
  ctx.lineTo(x, y);
  ctx.stroke();
  ctx.fillStyle = "#FFF8E1";
  ctx.shadowColor = "#FFD76A";
  ctx.shadowBlur = 8;
  ctx.beginPath();
  ctx.arc(x, y, 2.4, 0, Math.PI * 2);
  ctx.fill();
  ctx.restore();
}

function drawPot(ctx, x, y) {
  ctx.save();
  ctx.fillStyle = "#8A3B12";
  ctx.beginPath();
  ctx.moveTo(x - 15, y - 8);
  ctx.lineTo(x + 15, y - 8);
  ctx.lineTo(x + 10, y + 10);
  ctx.quadraticCurveTo(x, y + 14, x - 10, y + 10);
  ctx.closePath();
  ctx.fill();
  ctx.fillStyle = "#D4652F";
  ctx.fillRect(x - 17, y - 12, 34, 5);
  ctx.restore();
}

function drawSpark(ctx, spark, fade) {
  ctx.globalAlpha = Math.max(spark.life, 0) * fade;
  if (spark.kind === "flash") {
    const radius = spark.size * (0.45 + spark.life);
    const glow = ctx.createRadialGradient(spark.x, spark.y, 0, spark.x, spark.y, radius);
    glow.addColorStop(0, `rgba(255, 250, 230, ${spark.life})`);
    glow.addColorStop(0.45, `rgba(255, 153, 51, ${spark.life * 0.55})`);
    glow.addColorStop(1, "rgba(255, 153, 51, 0)");
    ctx.fillStyle = glow;
    ctx.beginPath();
    ctx.arc(spark.x, spark.y, radius, 0, Math.PI * 2);
    ctx.fill();
    return;
  }
  if (spark.kind === "ray") {
    ctx.strokeStyle = spark.color;
    ctx.lineWidth = spark.size;
    ctx.beginPath();
    ctx.moveTo(spark.x, spark.y);
    ctx.lineTo(spark.x - spark.vx * 5, spark.y - spark.vy * 5);
    ctx.stroke();
    return;
  }
  ctx.fillStyle = spark.color;
  ctx.beginPath();
  ctx.arc(spark.x, spark.y, spark.size, 0, Math.PI * 2);
  ctx.fill();
}

function sideAnchors(w, h, zone) {
  if (!zone) {
    const inset = Math.max(18, Math.min(56, w * 0.045));
    const lift = Math.min(140, Math.max(78, h * 0.24));
    return {
      pots: [
        { x: inset, y: h - 12 },
        { x: w - inset, y: h - 12 },
      ],
      sparklers: [
        { x: inset, y: h - lift },
        { x: w - inset, y: h - lift },
      ],
    };
  }
  const left = Math.max(8, zone.l * 0.42);
  const right = w - Math.max(8, (w - zone.r) * 0.42);
  const potY = Math.min(h - 6, zone.b + Math.max(12, (h - zone.b) * 0.5));
  const sparkY = zone.t + (zone.b - zone.t) * 0.76;
  return {
    pots: [
      { x: left, y: potY },
      { x: right, y: potY },
    ],
    sparklers: [
      { x: left, y: sparkY },
      { x: right, y: sparkY },
    ],
  };
}

/**
 * @param {HTMLCanvasElement} canvas
 * @param {{ durationMs?: number, spareEl?: () => Element | null, onDone?: () => void }} [options]
 * @returns {() => void}
 */
export function startCelebration(canvas, options = {}) {
  const durationMs = options.durationMs || 0;
  const spareEl = options.spareEl || null;
  const onDone = options.onDone || null;
  if (!canvas || typeof canvas.getContext !== "function") {
    if (onDone) onDone();
    return () => {};
  }
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    if (onDone) onDone();
    return () => {};
  }

  canvas.style.pointerEvents = "none";
  const reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const petals = [];
  const sparks = [];
  const view = { w: 1, h: 1 };
  let raf = 0;
  let stopped = false;
  let finished = false;
  const started = performance.now();
  let fireworkAt = 0;
  let crackerAt = 0;
  let potBurstAt = 0;
  const petalTarget = reduced ? 18 : 42;

  const resize = () => {
    const rect = canvas.getBoundingClientRect();
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const w = Math.max(1, Math.round(rect.width));
    const h = Math.max(1, Math.round(rect.height));
    const bw = Math.max(1, Math.round(w * dpr));
    const bh = Math.max(1, Math.round(h * dpr));
    if (canvas.width !== bw || canvas.height !== bh) {
      canvas.width = bw;
      canvas.height = bh;
    }
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    view.w = w;
    view.h = h;
  };

  const readZone = () => {
    if (!spareEl) return null;
    const el = spareEl();
    if (!el || !el.getBoundingClientRect) return null;
    const rect = el.getBoundingClientRect();
    if (rect.width < 2 || rect.height < 2) return null;
    const host = canvas.getBoundingClientRect();
    const pad = 8;
    return {
      l: rect.left - host.left - pad,
      t: rect.top - host.top - pad,
      r: rect.right - host.left + pad,
      b: rect.bottom - host.top + pad,
    };
  };

  const finish = () => {
    if (finished) return;
    finished = true;
    stopped = true;
    if (onDone) onDone();
  };

  const frame = (now) => {
    if (stopped) return;
    resize();
    const elapsed = now - started;
    const fading = durationMs > 0 && elapsed > durationMs - 800;
    const fade = fading ? Math.max(0, (durationMs - elapsed) / 800) : 1;
    const zone = readZone();
    if (spareEl && !zone) {
      raf = window.requestAnimationFrame(frame);
      return;
    }

    ctx.clearRect(0, 0, view.w, view.h);
    ctx.save();
    ctx.beginPath();
    ctx.rect(0, 0, view.w, view.h);
    if (zone) {
      ctx.rect(zone.l, zone.t, Math.max(0, zone.r - zone.l), Math.max(0, zone.b - zone.t));
      ctx.clip("evenodd");
    } else {
      ctx.clip();
    }
    ctx.globalAlpha = fade;

    const spawning = !fading && (durationMs === 0 || elapsed < durationMs - 800);
    const anchors = sideAnchors(view.w, view.h, zone);
    if (spawning) {
      while (petals.length < petalTarget) petals.push(makePetal(view.w, view.h, petals.length < 8));
      if (now - fireworkAt > (reduced ? 980 : 560)) {
        burstFirework(sparks, "left", view.w, view.h, reduced, zone);
        burstFirework(sparks, "right", view.w, view.h, reduced, zone);
        fireworkAt = now;
      }
      if (now - crackerAt > (reduced ? 760 : 300)) {
        popCracker(sparks, Math.random() < 0.5 ? "left" : "right", view.w, view.h, reduced, zone);
        crackerAt = now;
      }
      const potCount = reduced ? 1 : 2;
      const sparkCount = reduced ? 1 : 3;
      anchors.pots.forEach((pot) => emitFountain(sparks, pot.x, pot.y - 12, potCount, 2.8));
      anchors.sparklers.forEach((stick) => emitSparkler(sparks, stick.x, stick.y, sparkCount));
      if (now - potBurstAt > (reduced ? 2200 : 1500)) {
        anchors.pots.forEach((pot) => emitFountain(sparks, pot.x, pot.y - 12, reduced ? 10 : 22, 4.4));
        potBurstAt = now;
      }
    }
    anchors.pots.forEach((pot) => drawPot(ctx, pot.x, pot.y));
    anchors.sparklers.forEach((stick) => drawStick(ctx, stick.x, stick.y));

    for (let i = 0; i < petals.length; i += 1) {
      const petal = petals[i];
      petal.sway += 0.02;
      petal.x += petal.vx + Math.sin(petal.sway) * 0.4;
      petal.y += petal.vy;
      petal.rot += petal.spin;
      if (petal.y > view.h + 24) {
        petal.y = -18;
        petal.x = Math.random() * view.w;
      }
      if (petal.x < -20) petal.x = view.w + 10;
      if (petal.x > view.w + 20) petal.x = -10;
      drawPetal(ctx, petal);
    }

    for (let i = sparks.length - 1; i >= 0; i -= 1) {
      const spark = sparks[i];
      spark.x += spark.vx;
      spark.y += spark.vy;
      spark.vy += spark.g;
      spark.life -= spark.decay;
      if (spark.life <= 0) {
        sparks.splice(i, 1);
        continue;
      }
      drawSpark(ctx, spark, fade);
    }

    ctx.restore();
    if (durationMs > 0 && elapsed >= durationMs) {
      finish();
      return;
    }
    raf = window.requestAnimationFrame(frame);
  };

  resize();
  window.addEventListener("resize", resize);
  raf = window.requestAnimationFrame(frame);
  return () => {
    stopped = true;
    window.cancelAnimationFrame(raf);
    window.removeEventListener("resize", resize);
  };
}
